const bathroom = `Bathroom Repair Request
Hi,
I hope you're well. 
I need to tell you about the bathroom in my apartment. 
The taps are leaking, some tiles are broken, and there's mold, making it difficult to use. 
It's also causing a bad smell in the apartment.
Can the building company please fix the bathroom? 
It's important to stop these issues and make the apartment better for everyone. 
The work can start on November 15 and finish by December 10.
If you need more information or want to talk about this, you can call me at 555-555-5555 or email me at example@email.com.
Thank you for listening.
Take care,`
export default bathroom;